module.exports = __webpack_public_path__ + "static/media/WebEmer.0ff11b2e.png";